import './style.scss';

/**
 * コンテンツのAjax読み込みを行うクラス
 */
class LoadContents{
    constructor(params){
        this.settings = {
            ...this.defaults(),
            ...params,
        }
        this.init();
    }

    defaults(){
        return {
            targetSelector: '.js-load-contents'
        }
    }

    init(){
        let loadObjs = [];
        document.querySelectorAll(this.settings.targetSelector).forEach((obj) => {
            // 取得先が無い要素は読み込み対象外（"undefined" へのリクエストを投げない）
            if (!obj.dataset.endpoint) return;
            loadObjs.push(obj);
        });

        Promise.all(loadObjs.map(async (obj) => {
            this.showLoading(obj);
            const content = await this.loadContents(obj);
            this.setContents(content, obj);
        }));
    }

    showLoading(targetObj){
        targetObj.classList.add('is-loading');
        const loader = document.createElement('div');
        loader.className = 'load-contents-loader';
        loader.innerHTML = '<div class="load-contents-spinner"></div>';
        targetObj.appendChild(loader);
    }

    hideLoading(targetObj){
        targetObj.classList.remove('is-loading');
        const loader = targetObj.querySelector('.load-contents-loader');
        if (loader) {
            loader.remove();
        }
    }

    async loadContents(obj){
        const endpoint = obj.dataset.endpoint;
        const targetSelector = obj.hasAttribute('data-target') ? obj.dataset.target : 'body';
        const content = await fetch(endpoint)
            .then(response => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.text();
            })
            .then(data => {
                const parser = new DOMParser();
                const dom = parser.parseFromString(data, "text/html");
                return dom.querySelector(targetSelector);
            })
            .catch(error => {
                console.error('There has been a problem with your fetch operation:', error);
            });
        return content;
    }

    setContents(content, targetObj){
        // 取得失敗（loadContentsがcatchでundefinedを返す）／対象セレクタ不一致でnullのことがある。
        // ここで content.innerHTML を読むとTypeErrorで中断し hideLoading まで到達せず
        // スピナーが残り続けるため、中身は差し替えずに印だけ付けて抜ける
        // （プレースホルダに静的な代替コンテンツを置いておけばそれがそのまま残る）
        if (!content) {
            this.hideLoading(targetObj);
            targetObj.classList.add('is-load-error');
            return;
        }
        targetObj.innerHTML = content.innerHTML;
        this.hideLoading(targetObj);
        targetObj.dispatchEvent(new Event('onLoadContents'));
    }
}

export default LoadContents;
